import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hyperlink"
    }}>{`Hyperlink`}</h1>
    <p>{`Add hyperlink in the document through json data using anchor <a`}{`>`}{` tag.`}</p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How It Works`}</h2>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Notes Section": "Please refer to our terms and conditions over <a href=\\"https://www.adobe.com/legal/terms.html\\">here</a>"
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "11.249999999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/5530d/anchor-tag_sample.webp 320w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/0c8fb/anchor-tag_sample.webp 640w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/94b1e/anchor-tag_sample.webp 1280w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/0b34d/anchor-tag_sample.webp 1920w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/0a2ef/anchor-tag_sample.webp 1926w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/dd4a7/anchor-tag_sample.png 320w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/0f09e/anchor-tag_sample.png 640w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/bbbf7/anchor-tag_sample.png 1280w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/ac7a9/anchor-tag_sample.png 1920w", "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/5dd2a/anchor-tag_sample.png 1926w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/11e3d4fca76f01384b1145fb6bc2a31e/bbbf7/anchor-tag_sample.png",
            "alt": "Added hyperlink in the document through json data using anchor <a> tag",
            "title": "Added hyperlink in the document through json data using anchor <a> tag",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "13.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/5530d/anchor-tag1.webp 320w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/0c8fb/anchor-tag1.webp 640w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/94b1e/anchor-tag1.webp 1280w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/0b34d/anchor-tag1.webp 1920w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/8ba9e/anchor-tag1.webp 2264w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/dd4a7/anchor-tag1.png 320w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/0f09e/anchor-tag1.png 640w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/bbbf7/anchor-tag1.png 1280w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/ac7a9/anchor-tag1.png 1920w", "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/d090b/anchor-tag1.png 2264w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a6ca61d2128fa60b46455690486c7ec3/bbbf7/anchor-tag1.png",
            "alt": "Formatted output in the document when anchor tag is resolved",
            "title": "Formatted output in the document when anchor tag is resolved",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      